import { ThemeAPI } from '../src/themeAPI.ts';

const getSavedThemeLocal = ThemeAPI.getSavedThemeLocal;

export { getSavedThemeLocal };
